import { z } from "zod";

import { getNormalEnum } from "./pseudoEnums.js";

const UserInteractionLiteral = z.enum([
  "PROJECT_ONBOARDING_DISMISSED", // deprecated, no longer used
  "PROJECT_ONBOARDING_COLLAPSED", // deprecated, no longer used
  "EXPLORE_FROM_HERE_CALLOUT_DISMISSED",
  "NEW_PROJECT_TOUR_STARTED",
  "APP_VIEW_TOUR_STARTED",
  "TEMPLATE_SIDEBAR_TOOLTIP_SHOWN",
  "TEMPLATE_DATA_SOURCES_TOOLTIP_SHOWN",
  "DEBUG_MODE_CALLOUT_DISMISSED",
  "PRESENTATION_MODE_CALLOUT_DISMISSED",
  "NOTIFICATION_INBOX_OPENED",
  "DATA_MANAGER_DIALOG_DISMISSED",
  "HOME_PAGE_ONBOARDING_DISMISSED",
  "LEARN_SIDEBAR_DEFAULT_OPEN", // deprecated, no longer used
  "CALCS_AWARENESS_INDICATOR_DISMISSED", // deprecated, no longer used
  "ENDORSED_DATA_MAGIC_AWARENESS_INDICATOR_DISMISSED", // deprecated
  "CONDITIONAL_NOTIFICATION_ICON_CLICKED", // deprecated
  "ASK_MAGIC_INDICATOR_DISMISSED",
  "SAVED_VIEW_CTA_CLICKED", // deprecated
  "SEMANTIC_MODEL_AWARENESS_INDICATOR_DISMISSED", // deprecated, no longer used
  "MAGIC_2025_TOS_DIALOG_DISMISSED",
  "EXPLORE_ENDORSED_DATA_INFO_DISMISSED",
  "THREADS_TALK_TO_DATA_INFO_DISMISSED", // deprecated, superseded by CONTEXT_SETUP_PROMPT_CTA_DISMISSED
  "CONTEXT_SETUP_PROMPT_CTA_DISMISSED",
  "THREADS_INTRO_DIALOG_DISMISSED",
  "EVAL_INVITATION_DISMISSED",
  "THREADS_SLACK_POPOVER_DISMISSED",
  "THREADS_SLACK_ADMIN_POPOVER_DISMISSED",
  "TRIAL_ENDING_DIALOG_DISMISSED",
  "CREATOR_ONBOARDING_COMPLETED",
  "CHAT_WITH_APP_AWARENESS_INDICATOR_DISMISSED",
  "CHAT_WITH_APP_DISCOVERY_CARD_DISMISSED",
  "SQL_CELL_OUTPUT_AWARENESS_INDICATOR_DISMISSED",
  "CONTEXT_STUDIO_SETUP_DISMISSED",
  "AGENT_DESKTOP_NOTIFICATION_CTA_DISMISSED",
  "ASK_FROM_APP_AGENT_FAB_MOVED_DISMISSED",
  "UNLISTED_THREAD_NOTEBOOK_TAB_AWARENESS_DISMISSED",
  "AGENT_FIRST_CHAT_THREAD_ID",
  "PROJECT_THREAD_VISITED",
  "DATA_APP_PROMPT_TO_PROP_INTRO_DISMISSED",
  "ONBOARDING_CHECKLIST_CLAUDE_CONNECT_CLICKED",
  "ONBOARDING_CHECKLIST_CREATE_APP_PROMPT_PREFILLED",
]);

export const UserInteraction = getNormalEnum(UserInteractionLiteral);
export type UserInteraction = z.infer<typeof UserInteractionLiteral>;

// Using a Record instead of a Dictionary since we want to support other types of values.
export const UserInteractions = z.object({
  [UserInteraction.PROJECT_ONBOARDING_DISMISSED]: z.boolean(),
  [UserInteraction.PROJECT_ONBOARDING_COLLAPSED]: z.boolean(),
  [UserInteraction.EXPLORE_FROM_HERE_CALLOUT_DISMISSED]: z.boolean(),
  [UserInteraction.NEW_PROJECT_TOUR_STARTED]: z.boolean(),
  [UserInteraction.APP_VIEW_TOUR_STARTED]: z.boolean(),
  [UserInteraction.TEMPLATE_SIDEBAR_TOOLTIP_SHOWN]: z.boolean(),
  [UserInteraction.TEMPLATE_DATA_SOURCES_TOOLTIP_SHOWN]: z.boolean(),
  [UserInteraction.DEBUG_MODE_CALLOUT_DISMISSED]: z.boolean(),
  [UserInteraction.PRESENTATION_MODE_CALLOUT_DISMISSED]: z.boolean(),
  [UserInteraction.NOTIFICATION_INBOX_OPENED]: z.boolean(),
  [UserInteraction.HOME_PAGE_ONBOARDING_DISMISSED]: z.boolean(),
  [UserInteraction.LEARN_SIDEBAR_DEFAULT_OPEN]: z.boolean(),
  [UserInteraction.CALCS_AWARENESS_INDICATOR_DISMISSED]: z.boolean(),
  [UserInteraction.ENDORSED_DATA_MAGIC_AWARENESS_INDICATOR_DISMISSED]:
    z.boolean(),
  [UserInteraction.CONDITIONAL_NOTIFICATION_ICON_CLICKED]: z.boolean(),
  [UserInteraction.ASK_MAGIC_INDICATOR_DISMISSED]: z.boolean(),
  [UserInteraction.SAVED_VIEW_CTA_CLICKED]: z.boolean(),
  [UserInteraction.SEMANTIC_MODEL_AWARENESS_INDICATOR_DISMISSED]: z.boolean(),
  [UserInteraction.MAGIC_2025_TOS_DIALOG_DISMISSED]: z.boolean(),
  [UserInteraction.EXPLORE_ENDORSED_DATA_INFO_DISMISSED]: z.boolean(),
  [UserInteraction.THREADS_TALK_TO_DATA_INFO_DISMISSED]: z.boolean(),
  [UserInteraction.CONTEXT_SETUP_PROMPT_CTA_DISMISSED]: z.boolean(),
  [UserInteraction.THREADS_INTRO_DIALOG_DISMISSED]: z.boolean(),
  [UserInteraction.TRIAL_ENDING_DIALOG_DISMISSED]: z.boolean(),
  [UserInteraction.CREATOR_ONBOARDING_COMPLETED]: z.boolean(),
  [UserInteraction.EVAL_INVITATION_DISMISSED]: z.boolean(),
  [UserInteraction.THREADS_SLACK_POPOVER_DISMISSED]: z.boolean(),
  [UserInteraction.THREADS_SLACK_ADMIN_POPOVER_DISMISSED]: z.boolean(),
  [UserInteraction.CHAT_WITH_APP_AWARENESS_INDICATOR_DISMISSED]: z.boolean(),
  [UserInteraction.CHAT_WITH_APP_DISCOVERY_CARD_DISMISSED]: z.boolean(),
  [UserInteraction.SQL_CELL_OUTPUT_AWARENESS_INDICATOR_DISMISSED]: z.boolean(),
  [UserInteraction.CONTEXT_STUDIO_SETUP_DISMISSED]: z.boolean(),
  [UserInteraction.AGENT_DESKTOP_NOTIFICATION_CTA_DISMISSED]: z.boolean(),
  [UserInteraction.ASK_FROM_APP_AGENT_FAB_MOVED_DISMISSED]: z.boolean(),
  [UserInteraction.UNLISTED_THREAD_NOTEBOOK_TAB_AWARENESS_DISMISSED]:
    z.boolean(),
  // Id of the first thread the user ran the agent in, or "" if they never have.
  [UserInteraction.AGENT_FIRST_CHAT_THREAD_ID]: z.string(),
  [UserInteraction.PROJECT_THREAD_VISITED]: z.boolean(),
  [UserInteraction.DATA_APP_PROMPT_TO_PROP_INTRO_DISMISSED]: z.boolean(),
  [UserInteraction.ONBOARDING_CHECKLIST_CLAUDE_CONNECT_CLICKED]: z.boolean(),
  [UserInteraction.ONBOARDING_CHECKLIST_CREATE_APP_PROMPT_PREFILLED]:
    z.boolean(),
});
export type UserInteractions = z.infer<typeof UserInteractions>;
export const PartialUserInteractions = z
  .object(UserInteractions.shape)
  .partial();
export type PartialUserInteractions = z.infer<typeof PartialUserInteractions>;
